; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ContentSearch/MultiViewSearchResults',["jquery", "eventManager", "knockout", "ScoreMultiViewSearchResults", "score_bootstrap/Events/SearchResponseEvent", "score_bootstrap/Models/Search/SearchRequest"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("knockout"), require("ScoreSearchResults"), require("score_bootstrap/Events/SearchResponseEvent"), require("score_bootstrap/Models/Search/SearchRequest")) :
            console && console.error('MultiViewSearchResults does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, ko, ScoreMultiViewSearchResults, SearchResponseEvent, SearchRequest) {

    function MultiViewSearchResults(scope, uniqueId, refreshEvents, showTransmitMsg, stateChangeTransmitMsg, showMoreActionMsg, showQvActionMsg, lazySearch) {
        // read query from GET parapmeter if any passed on page load
        this.searchQuery = ko.observable(new SearchRequest().query);

        // subscribe to search result update and read query from the response
        eventManager.subscribe(SearchResponseEvent.eventName, this._handleSearchQueryUpdate.bind(this));

        // replace token received from the server side with a knockout element
        var $counter = $('.score-results-summary', scope);
        if ($counter.length) {
            $counter.attr('data-bind', 'visible: (numberOfResults() > 0 && serviceUnavailable() === false && showNumberOfResultsLabel())');
            $counter.html($counter.html().replace('%searchquery%', '<span data-bind="text: searchQuery"></span>'));
        }

        // call inherited class constructor
        ScoreMultiViewSearchResults.call(this, scope, uniqueId, refreshEvents, showTransmitMsg, stateChangeTransmitMsg, showMoreActionMsg, showQvActionMsg, lazySearch);
    }

    // inherit 
    MultiViewSearchResults.prototype = Object.create(ScoreMultiViewSearchResults.prototype);

    // SCORE normally hides the # of results label unless the user is searching for something
    MultiViewSearchResults.prototype.showNumberOfResultsLabel = function showNumberOfResultsLabel() {
        return true; //this.searchQuery() && this.searchQuery().length > 0;
    }

    MultiViewSearchResults.prototype._handleSearchQueryUpdate = function _handleSearchQueryUpdate(response) {
        this.searchQuery(response.query);
    }

    MultiViewSearchResults.init = function init(args) {
        if (args.IsEditorEditing === true) {
            $(args.scope).removeClass("js-hide-on-load");
            return null;
        }

        return new MultiViewSearchResults(
            args.scope,
            args.UniqueId,
            args.RefreshActionMessages || [],
            args.ShowMessagesTransmitting || [],
            args.StateChangeMessagesToTransmitOn || [],
            args.ShowMoreMessagesToPerformOn || [],
            args.ShowQuickViewMessagesToPerformOn || [],
            args.LazySearch);
    };

    return MultiViewSearchResults;
}));
